import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { sportCategories } from '@/mocks/sportsData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-9 h-9 flex items-center justify-center">
            <i className={`ri-fire-line text-2xl ${isScrolled || !isHome ? 'text-primary-500' : 'text-background-50'}`}></i>
          </div>
          <span className={`font-heading text-xl font-bold tracking-wide ${isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'}`}>
            开体育在线
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/'
                ? isScrolled || !isHome ? 'text-primary-500' : 'text-background-50'
                : isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50'
            }`}
          >
            首页
          </Link>
          {sportCategories.slice(0, 4).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-500'
                  : isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/about'
                ? 'text-primary-500'
                : isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-2xl ${isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'} ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link to="/" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">首页</Link>
            {sportCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}